'use client'

import { sanitizeRedirectPath } from '@/lib/auth/redirect'

export function navigateAfterAuth(path: string) {
  window.location.assign(sanitizeRedirectPath(path))
}
